import { useEffect, useState } from "react"

const useConditionalRenderingAnimation = (isOpen: boolean, duration = 300) => {
  const [shouldRender, setShouldRender] = useState(isOpen)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true)
      setTimeout(() => setIsAnimating(true), 10)
    } else {
      setIsAnimating(false)
      const timer = setTimeout(() => setShouldRender(false), duration)
      return () => clearTimeout(timer)
    }
  }, [isOpen, duration])

  return { shouldRender, isAnimating }
}

export default useConditionalRenderingAnimation
